export default function (c) {
    return c('router-view');
}
  